import {
  ContentSection,
  VideoBlock,
  Wrapper,
  PlayButton,
  Triangle
} from "./styles";
import { StyledButton } from "components/generic";
import { NavLink } from "react-router-dom";
import { useRef, useState } from "react";
import videoSrc1 from "../../assets/videos/Student over unieke woonplek in tuinhuisje hospita Bilthoven.mp4";
import videoSrc2 from "../../assets/videos/Student woont in tuinhuisje bij hospita in Bilthoven.mp4";

interface IVideoSection {
  title: string;
  text: string | string[];
  buttonText: string;
  previewSrc: string;
  reverse?: boolean;
  sharedRegisterUrl: string;
  pageKey: string;
}

export const VideoSection: React.FC<IVideoSection> = ({
  title,
  sharedRegisterUrl,
  text,
  buttonText,
  previewSrc,
  reverse = false,
  pageKey
}) => {
  const [isPlayed, setIsPlayed] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoSrc = pageKey === "hostPage" ? videoSrc1 : videoSrc2;

  const handlePlay = () => {
    setIsPlayed(true);
    videoRef.current!.play();
  };

  return (
    <Wrapper flexEnd={reverse}>
      <div>
        <VideoBlock flexEnd={reverse} preview={previewSrc}>
          <div>
            {!reverse && (
              <video
                ref={videoRef}
                preload="none"
                controls={isPlayed}
                autoPlay={false}
                src={videoSrc}
              ></video>
            )}
            {!isPlayed && (
              <div>
                {!reverse && (
                  <PlayButton onClick={handlePlay}>
                    <Triangle />
                  </PlayButton>
                )}
              </div>
            )}
          </div>
        </VideoBlock>
        <ContentSection>
          <div>{title}</div>
          <div>
            {typeof text === "string" ? (
              text
            ) : (
              <ul style={{ paddingLeft: 20 }}>
                {text.map((content) => (
                  <li key={content}>{content}</li>
                ))}
              </ul>
            )}
          </div>
          <NavLink to={sharedRegisterUrl}>
            <StyledButton p="16px 32px">{buttonText}</StyledButton>
          </NavLink>
        </ContentSection>
      </div>
    </Wrapper>
  );
};
